import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorBookingItemTree } from '../editor-booking-item-tree/editor-booking-item-tree.model';
import { EditorBookingItemTreeStore } from '../editor-booking-item-tree/editor-booking-item-tree.store';
import { EditorBookingItemTreeDataEditStore } from '../editor-booking-item-tree-data-edit/editor-booking-item-tree-data-edit.store';
import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorDialogStore } from '../editor-dialog/editor-dialog.store';


@Component({
    // tslint:disable-next-line:component-selector
    selector: '[eas-editor-booking-item-tree-extra-roles]',
    templateUrl: './editor-booking-item-tree-extra-roles.component.html',
    styleUrls: ['./editor-booking-item-tree-extra-roles.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemTreeExtraRolesComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  itemTree: EditorBookingItemTree;

  extraRolesNamesAsString: string = null;

  constructor(
    private itemTreeStore: EditorBookingItemTreeStore,
    private editorData: EditorDataService,
    private itemTreeDataEditStore: EditorBookingItemTreeDataEditStore,
    private itemDialogStore: EditorDialogStore
  ) {

  }

  ngOnInit() {
    combineLatest(this.itemTreeStore.itemTree$, this.editorData.roleNames$)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(([itemTree, roleNames]) => {
        this.extraRolesNamesAsString = itemTree === null ? null : itemTree.getExtraRolesAsString(roleNames);
      });

    this.itemTreeStore.itemTree$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(itemTree => this.itemTree = itemTree);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onEdit() {
    this.itemTreeDataEditStore.startEditing({ name: 'extraRoles' });
    this.itemDialogStore.editBookingItemTree();
    return false;
  }
}
